import ReceptionRoutes from './ReceptionRoutes';

export * from './login';

export default ReceptionRoutes;
